module.exports = __webpack_public_path__ + "static/media/exchange.635d1d6c.svg";